import React, { useState } from 'react';
import './index.css';

type TextInputProps = {
    children?: React.ReactNode;
    className?: string;
    inputClassName?: string;
    id?: string;
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    type?: React.HTMLInputTypeAttribute;
    value?: string;
    disabled?: boolean;
};

function TextInput({
    children,
    className,
    inputClassName,
    name,
    onChange,
    label,
    placeholder,
    required,
    type,
    value,
    disabled
}: TextInputProps) {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div className={`textInput__wrapper ${className}`}>
            {label &&
                <p className={value || isFocused 
                    ? 'textInput__label--focused'
                    : 'textInput__label'
                }>
                    {label} {required && '*'}
                </p>
            }
            <input 
                className={`${value || isFocused
                    ? 'textInput--focused'
                    : 'textInput'
                } ${inputClassName}`}
                id={name}
                name={name}
                onBlur={() => setIsFocused(false)}
                onFocus={() => setIsFocused(true)}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                type={type}
                value={value}
                disabled={disabled}
            >
                {children}
            </input>
        </div>
    )
}

export default TextInput;